import qs from "query-string";

export function getDebuggerSetting(search) {
  const parse = qs.parse(search);
  const debug = parse.debug;
  return debug && "true" === debug.toLowerCase();
}
